import { render } from "./ShareButton.vue?vue&type=template&id=1a1de519"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=1a1de519&lang=css"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__